<template>
	<div class="white pos-rel rounded-lg min-h-screen">
		<div class="header">
			<v-btn fab flat @click="closeModal">
				<v-icon>close</v-icon>
			</v-btn>

			<div>Invitations</div>
			<v-btn
				@click="inviteCreator"
				color="primary"
				class="text-none rounded-pill"
			>
				Invite Host
			</v-btn>
		</div>

		<v-card class="pa-2 ma-2" :class="{ 'pa-5': !isSmallScreen }">
			<v-layout
				class="d-flex flex-row"
				:class="{
					'flex-column': isSmallScreen,
					'align-center': !isSmallScreen
				}"
			>
				<v-select
					v-model="selectedStatusFilter"
					:items="capitalizedOptions"
					label="Select status filter"
					class="ml-2 mr-2"
					outlined
				></v-select>

				<v-text-field
					v-model="searchForHandle"
					:label="`Search By Handle `"
					:color="themeColor"
					class="ml-2 mr-2"
				/>

				<v-btn
					:disabled="!searchForHandle && !selectedStatusFilter"
					class="white--text rounded-pill"
					color="primary"
					@click="handleSearch"
				>
					Search
				</v-btn>
			</v-layout>
			<v-layout>
				<v-flex class="mt-3">
					<v-data-table
						:headers="tableHeaders"
						:items="allInvites"
						:disable-pagination="true"
						hide-default-footer
						:loading="isGetInviteLoading"
						:rows-per-page-items="[10, 20, 50, 100]"
					>
						<template v-slot:items="props">
							<td>{{ `@${props.item.userHandle}` || "NA" }}</td>

							<td>{{ props.item.metadata.hostName || "-" }}</td>

							<td>
								{{ props.item.metadata.mobile || "NA" }}
							</td>
							<td>
								{{ gender[props.item.metadata.gender] || "NA" }}
							</td>
							<td>
								{{ props.item.metadata.language || "NA" }}
							</td>

							<td>
								{{
									capitalizeFirstLetter(
										statusTextMapping[props.item.status] ||
											props.item.status
									)
								}}
							</td>

							<td>
								{{
									new Date(
										props.item.createdAt
									).toLocaleString()
								}}
							</td>
							<td v-if="!isStatusPending(props.item.status)">
								{{
									new Date(
										props.item.updatedAt
									).toLocaleString()
								}}
							</td>

							<td v-if="isStatusPending(props.item.status)">
								{{
									new Date(
										props.item.expiresAt
									).toLocaleString()
								}}
							</td>

							<td>
								<v-layout
									class="d-flex flex-column"
									v-if="isStatusPending(props.item.status)"
								>
									<v-tooltip bottom>
										<template #activator="{ on }">
											<div
												class="d-flex allCenteredChild"
											>
												<v-btn
													small
													text
													flat
													v-on="on"
													@click="
														copyToClipBoard(
															props.item.inviteUrl
														)
													"
												>
													<v-icon color="grey"
														>content_copy</v-icon
													>
													<div class="ml-2">COPY</div>
												</v-btn>
											</div>
										</template>
										<span>Copy invite url</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on }">
											<div
												class="d-flex allCenteredChild"
											>
												<v-btn
													small
													text
													flat
													v-on="on"
													@click="
														handleDialogBox(
															props.item
														)
													"
												>
													<v-icon color="red"
														>close</v-icon
													>
													<div class="text-red ml-2">
														CANCEL
													</div>
												</v-btn>
											</div>
										</template>
										<span>Cancel invite</span>
									</v-tooltip>
								</v-layout>
								<v-layout v-else> - </v-layout>
							</td>
						</template>
					</v-data-table>
				</v-flex>
			</v-layout>
		</v-card>
		<v-dialog persistent max-width="290" v-model="confirmationDialog">
			<v-card>
				<v-card-text
					>Are you sure you want to cancel the invite?</v-card-text
				>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn
						color=" red darken-1"
						flat="flat"
						@click="processCancelInvite"
						:loading="isProcessInviteLoading"
					>
						Yes
					</v-btn>

					<v-btn
						color="black darken-1"
						flat="flat"
						@click="confirmationDialog = false"
					>
						Close
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			width="600px"
			fullscreen
			hide-overlay
			v-model="inviteCreatorDialog"
		>
			<div>
				<template v-if="inviteCreatorDialog">
					<invite-creator
						model="inviteCreatorDialog"
						:themeInputColor="themeColor"
						@CLOSE_INVITE_MODAL="closeInviteModal"
						@INVITE_CREATOR="confirmAndInviteCreator"
						:loading="inviteCreatorLoading"
						:triggerDataReset="triggerDataReset"
					/>
				</template>
			</div>
		</v-dialog>
		<v-dialog v-model="showInviteCard" width="500">
			<v-card class="transaction-card">
				<div
					class="headercard success justify-center align-center d-flex text-center"
				>
					{{ successHeaderText }}
				</div>
				<div class="bottom-part">
					<div class="text-center">
						Please ask the creator to log into the correct Moj
						account, and click this link from their mobile to accept
						the invite:
					</div>
					<div class="link-container">
						<div class="link-style">{{ inviteLink }}</div>
						<v-btn
							outline
							class="rounded-pill"
							color="primary"
							@click="copyText(inviteLink)"
						>
							Copy Link
						</v-btn>
					</div>
					<v-btn
						color="primary"
						class="rounded-pill"
						@click="
							inviteLink = '';
							showInviteCard = false;
						"
					>
						Done
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { SHOW_ALERT } from "@/store/action-types";
import { mapState } from "vuex";
import InviteCreator from "./invite-creator.vue";
import { callMojAgency } from "./moj-agency-api";
export default {
	name: "InvitationTable",
	props: ["model", "themeColor", "agencyId"],
	data() {
		return {
			isProcessInviteLoading: false,
			selectedStatusFilter: 1,
			statusTextMapping: {
				PENDING: "PENDING",
				ACCEPTED: "ACCEPTED",
				REJECTED: "REJECTED",
				MANUAL_REVIEW_PENDING: "Moj Review Pending",
				MANUAL_REVIEW_ACCEPTED: "Accepted",
				MANUAL_REVIEW_REJECTED: "Moj Review Rejected"
			},
			options: [
				{ text: "ALL", value: -1 },
				{ text: "PENDING", value: 1 },
				{ text: "ACCEPTED", value: 2 },
				{ text: "REJECTED", value: 3 },
				{ text: "CANCELLED", value: 4 },
				{ text: "EXPIRED", value: 5 }
			],
			searchForHandle: null,
			confirmationDialog: false,
			allInvites: [],
			cancelInviteMetadata: null,
			gender: {
				M: "Male",
				F: "Female"
			},
			headers: [
				{
					text: "Moj Handle",
					value: "mojhandle",
					align: "left",
					sortable: false
				},
				{
					text: "Host Name",
					value: "hostName",
					align: "left",
					sortable: false
				},
				{
					text: "Phone Number",
					align: "left",
					value: "phoneNumber",
					sortable: false
				},
				{
					text: "Host Gender",
					align: "left",
					value: "hostGender",
					sortable: false
				},
				{
					text: "Host Language",
					align: "left",
					value: "hostLanguage",
					sortable: false
				},
				{
					text: "Status",
					value: "status",
					align: "left",
					sortable: false
				},
				{
					text: "Invited Date",
					align: "left",
					value: "invitedDate",
					sortable: false
				},
				{
					text: "Last Updated On",
					value: "lastUpdatedOn",
					align: "left",
					sortable: false
				},

				{
					text: "Expires On",
					value: "expiresOn",
					align: "left",
					sortable: false
				},
				{
					text: "Actions",
					value: "actions",
					align: "left",
					sortable: false
				}
			],
			pagination: {
				rowsPerPage: 100,
				page: 1
			},
			isGetInviteLoading: true,
			inviteCreatorDialog: false,
			showInviteCard: false,
			inviteCreatorLoading: false,
			triggerDataReset: false,
			inviteLink: "",
			successHeaderText: "Invitation created successfully"
		};
	},
	components: {
		"invite-creator": InviteCreator
	},
	mounted() {
		this.fetchTableData();
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN
		}),
		capitalizedOptions() {
			return this.options.map(option => {
				return {
					...option,
					text: this.capitalizeFirstLetter(option.text)
				};
			});
		},
		isSmallScreen() {
			let screen_size = this.$vuetify.breakpoint.name;
			return screen_size === "xs" || screen_size === "sm";
		},
		tableHeaders() {
			let headers = this.headers;
			if (this.selectedStatusFilter === 1) {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				headers = headers.filter(
					header => header.value !== "lastUpdatedOn"
				);
			} else {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				headers = headers.filter(
					header => header.value !== "expiresOn"
				);
			}
			return headers;
		}
	},
	methods: {
		capitalizeFirstLetter(string) {
			return (
				string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
			);
		},
		isStatusPending(status) {
			return ["PENDING", "MANUAL_REVIEW_PENDING"].includes(status);
		},
		handleSearch() {
			if (this.selectedStatusFilter !== -1) {
				this.selectedStatusFilter = -1;
			} else {
				this.fetchTableData();
			}
		},
		inviteCreator() {
			this.inviteCreatorDialog = true;
		},
		getOptionsText() {
			let statusOption = this.options.find(
				option => option.value === this.selectedStatusFilter
			).text;
			if (["PENDING", "ACCEPTED", "REJECTED"].includes(statusOption)) {
				statusOption += `,MANUAL_REVIEW_${statusOption}`;
			}
			return statusOption;
		},
		getAllStatusOptions() {
			return `PENDING,ACCEPTED,REJECTED,MANUAL_REVIEW_PENDING,MANUAL_REVIEW_ACCEPTED,MANUAL_REVIEW_REJECTED,CANCELLED,EXPIRED`;
		},
		async processCancelInvite() {
			this.isProcessInviteLoading = true;
			const inviteId = this.cancelInviteMetadata.inviteId;

			try {
				await callMojAgency(this.ACCESS_TOKEN, "cancelInvite", {
					inviteId
				});
				this.isProcessInviteLoading = false;
				this.cancelInviteMetadata = false;
				this.confirmationDialog = false;
				this.fetchTableData();
			} catch (e) {
				const errMsg =
					e.message || "Error occured while cancelling invite";
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: errMsg
				});
				this.isProcessInviteLoading = false;
				this.cancelInviteMetadata = false;
				this.confirmationDialog = false;
			}
		},
		handleDialogBox(metaData) {
			this.confirmationDialog = true;
			this.cancelInviteMetadata = metaData;
		},
		async copyToClipBoard(text) {
			try {
				if (!text) {
					throw new Error("No text provided to copy");
				}
				text = `https://mojapp.in/web?url=https://creators.mojapp.in${text}`;
				await navigator.clipboard.writeText(text);
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Copied Invite URL"
				});
			} catch (e) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Error occured while copying invite url"
				});
			}
		},
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		},
		closeInviteModal(payload) {
			this[payload] = false;
		},
		async fetchTableData() {
			this.isGetInviteLoading = true;
			this.allInvites = [];
			const params = {
				status:
					this.selectedStatusFilter === -1
						? this.getAllStatusOptions()
						: this.getOptionsText()
			};
			if (this.searchForHandle) params.handle = this.searchForHandle;

			try {
				const response = await callMojAgency(
					this.ACCESS_TOKEN,
					"getInvites",
					params
				);
				this.allInvites = response;
				this.isGetInviteLoading = false;
			} catch (e) {
				const errMsg =
					e.message || "Error occured while fetching invite list";
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: errMsg
				});
				this.isGetInviteLoading = false;
			}
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		copyText(text) {
			try {
				let input = document.createElement("input");
				input.setAttribute("value", text);
				document.body.appendChild(input);
				input.select();
				document.execCommand("copy");
				document.body.removeChild(input);
				this.showAlert("Copied successfully!");
			} catch (e) {
				this.showAlert("Error occured while copying");
			}
		},
		async confirmAndInviteCreator(hostDetails) {
			if (!this.inviteCreatorLoading) {
				this.inviteCreatorLoading = true;
				let handle = hostDetails.handle;
				const match = hostDetails.handle.match(/@([^?]+)/);
				if (match) {
					handle = match[1];
				}
				const payload = {
					userHandle: handle,
					metadata: {
						mobile: hostDetails.phone,
						age: hostDetails.age,
						gender: hostDetails.gender,
						language: hostDetails.language,
						genre: hostDetails.genre,
						instagram: hostDetails.instagramUrl,
						hostName: hostDetails.hostName
					}
				};
				try {
					const response = await callMojAgency(
						this.ACCESS_TOKEN,
						"createInvite",
						payload
					);
					if (response.message) {
						this.showAlert(response.message);
						if (response.inviteUrl) {
							this.inviteCreatorDialog = false;
							this.showInviteCard = true;
							this.inviteLink = `https://mojapp.in/web?url=https://creators.mojapp.in${response.inviteUrl}`;
							this.triggerDataReset = !this.triggerDataReset;
							this.successHeaderText =
								"Invitation already exists";
						}
					} else if (response.inviteId) {
						this.inviteCreatorDialog = false;
						this.showInviteCard = true;
						this.inviteLink = `https://mojapp.in/web?url=https://creators.mojapp.in${response.inviteUrl}`;
						this.triggerDataReset = !this.triggerDataReset;
						this.successHeaderText =
							"Invitation created successfully";
					}
				} catch (e) {
					this.showAlert(e.message);
				}
				this.inviteCreatorLoading = false;
			}
		}
	},
	watch: {
		selectedStatusFilter(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.fetchTableData();
			}
		}
	}
};
</script>

<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.text-red {
	color: red;
}
.ml-2 {
	margin-left: 8px;
}
.filter-width {
	width: 200px;
}
.link-container {
	display: flex;
	flex-direction: column;
}
.link-style {
	font-size: 15px;
	font-weight: 400;
	text-align: center;
	margin: 20px 0;
}
.transaction-card {
	border-radius: 8px;
}
.transaction-card > .bottom-part {
	font-size: 16px;
	font-weight: 500;
	display: grid;
	align-items: center;
	padding: 16px;
}
.transaction-card > .headercard {
	color: white;
	text-transform: uppercase;
	font-size: 18px;
	padding: 8px;
	font-weight: 600;
	text-align: center;
}
.success {
	background: green;
}
</style>
